import { useMediaQuery, useTheme } from "@mui/material";
import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";
import UserContext from "../../context/User";
import DHeader from "./desktop.header";
import Analytics from "../../utils/analytics";
import { useTranslation } from 'react-i18next';
import { myLoyaltyBalance, myLoyaltyVouchers } from "../../apollo/server";

const MY_LOYALTY_VOUCHERS = gql`${myLoyaltyVouchers}`;
const MY_LOYALTY_BALANCE = gql`${myLoyaltyBalance}`;

const TITLE = "RushmyFood";
const NAME = "...";

// Pages that should show the simple header (no delivery/pickup toggle, search, etc.)
const SIMPLE_HEADER_PATHS = [
  "/",
  "/privacy",
  "/terms"
];

const savedLanguage = localStorage.getItem('enatega-language');
console.log('Saved language in localStorage:', savedLanguage);

function Header() {
  const { t } = useTranslation();
  const location = useLocation();
  const showFullHeader = !SIMPLE_HEADER_PATHS.includes(location.pathname);

  const NAVITEMS = [
    {
      title: t('titleOrders'),
      link: "/orders",
    },
    {
      title: t('titleProfile'),
      link: "/profile",
    },
    {
      title: t('titleSettings'),
      link: "/settings",
    },
    {
      title: t('titleLogout'),
      link: "/login",
    },
  ];
  const theme = useTheme();
  const { logout, loadingProfile, profile, cartCount, otherCartsCount } =
    useContext(UserContext);
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { data: voucherData } = useQuery(MY_LOYALTY_VOUCHERS, {
    fetchPolicy: 'network-only',
    skip: !profile,
  });
  const loyaltyVouchers = voucherData?.myLoyaltyVouchers || [];
  // Every screen mounts its own header, so the balance is read from cache;
  // the Rewards screen refetches it from the network.
  const { data: balanceData } = useQuery(MY_LOYALTY_BALANCE, {
    fetchPolicy: 'cache-first',
    skip: !profile,
  });
  const points = balanceData?.myLoyaltyPoints?.balance;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async (route) => {
    if (route === t('titleLogout')) {
      logout();
      await Analytics.track(Analytics.events.USER_LOGGED_OUT);
      await Analytics.identify(null, null);
    }
    setAnchorEl(null);
  };
  return (
    <DHeader
      navitems={NAVITEMS}
      title={TITLE}
      close={handleClose}
      open={handleOpen}
      anchor={anchorEl}
      name={loadingProfile ? NAME : profile?.name}
      cartCount={cartCount + (otherCartsCount || 0)}
      // With carts parked elsewhere the bag can't assume which one is meant —
      // send the customer to pick. One cart still goes straight to checkout.
      cartHref={otherCartsCount > 0 ? "/carts" : "/checkout"}
      mobile={mobile}
      showFullHeader={showFullHeader}
      loyaltyVouchers={loyaltyVouchers}
      points={typeof points === 'number' ? points : undefined}
    />
  );
}

export default React.memo(Header);
